// eslint-disable-next-line import/prefer-default-export
export const FRIENDBUY_REFERRAL_TYPES = {
    INFLUENCER: 'influencer',
};

export const FRIENDBUY_WIDGET_ACTION_NAMES = [
    'advocateEmailCaptured',
    'copyText',
    'friendEmailCaptured',
    'transitionScreen',
    'widgetClosed',
];
